import { FC } from "react";
import { Input } from "antd";
import {
  GlobalModalStyles,
  StyledFormTextWrapper,
  StyledModal,
  StyledSelectForm,
  StyledTextArea,
} from "./styled";
import { CloseIcon } from "../icons/CloseIcon";
import { ArrowDown } from "../icons/ArrowDown";

import { TComment } from "../../types";

interface IAddCommentModalProps {
  onCancel: () => void;
  onSubmit: (value: TComment) => void;
}

export const AddCommentModal: FC<IAddCommentModalProps> = ({
  onCancel,
  onSubmit,
}) => (
  <>
    <GlobalModalStyles />

    <StyledModal
      okText="Оставить замечание"
      cancelText="Отмена"
      closeIcon={<CloseIcon />}
      className="add-comment-modal"
      onCancel={onCancel}
      onOk={(values: Record<string, any>) =>
        onSubmit({
          description: values.description,
          documentationId: String(values.documentationId),
          title: values.title,
        })
      }
      title="Оставить замечание"
      open={true}
      width={464}
      style={{ fontWeight: 600, fontSize: "16px" }}
    >
      <StyledFormTextWrapper
        colon={false}
        label="Том для замечания"
        maxLength={128}
        name="volume"
      >
        <StyledSelectForm
          allowClear={false}
          suffixIcon={<div className="arrow-icon">
            <ArrowDown  />
            </div>}
          options={[
            { name: "ПУ-1-3.2-22-РД-КЖ2.4.pdf", id: 111 },
            { name: "ПУ-3.2-23-РД-КЖ2.4.pdf", id: 222 },
            { name: "ПУ-3.2-21-РД-КЖ2.4.pdf", id: 333 },
          ].map((el) => ({
            label: el.name,
            value: el.id,
          }))}
          placeholder="Выберите том для замечания"
        />
      </StyledFormTextWrapper>

      <StyledFormTextWrapper
        colon={false}
        label="Название замечания"
        maxLength={128}
        name="title"
      >
        <Input
          style={{ color: "#4A5368" }}
          placeholder="Укажите название замечания"
        />
      </StyledFormTextWrapper>

      <StyledFormTextWrapper
        colon={false}
        label="Описание замечания"
        maxLength={8192}
        name="description"
      >
        <StyledTextArea
          style={{ color: "#4A5368" }}
          placeholder="Что некорректно отражено или непонятно из документации"
          rows={3}
        />
      </StyledFormTextWrapper>
    </StyledModal>
  </>
);
